import { LatLng } from "geolocation-utils";

import { api } from "api";
import { Utils } from "utils";
import { Prettify } from "types";
import { Path } from "services/path";

interface Request {
  coordinates: LatLng[];
}

export const buildInitialRoute = async (props: Prettify<Request>) => {
  const { coordinates } = props;
  const { convertToPoints } = Utils.Graphhopper;

  const initialRoute = await api.graphhopper.buildRoute({
    optimize: false,
    withAlternativeRoads: true,
    points: convertToPoints(coordinates),
  });

  const path = new Path(initialRoute.paths[0]);
  return Promise.resolve(path);
};
